module.exports = __webpack_public_path__ + "img/about-us.722f9c3b.jpg";